<arm-dialog (onSubmit)="ok()"
            [hideCancelButton]="true"
            [title]="'Action Failed'">

  <div class="inline-content">


    <div class="message-header">
      <mat-icon class="error-icon" color="warn">error</mat-icon>
      <span class="header-inline">One or more errors occurred. See details below.</span>
    </div>

      <div class="failed-multiple-actions-dialog-message">

        <div *ngIf="data.message">
          <ng-container *ngFor="let error of onlyErrors; let i = index">
            <ac-line-separator [isCollapsible]="true" [collapsed]="i === 0 ? false : true" [title]="'Error ' + (i + 1)" >
              <p>{{error.description}}</p>
            </ac-line-separator>
          </ng-container>
        </div>
      </div>
  </div>

</arm-dialog>
